import Gallery from "@/domain/metrics/gallery";

export function observeMedia(element, query, mediaId, isVideo = false) {
    const mediaEl = this.$el.querySelector(query)
    if (!mediaEl) return

    const observer = new IntersectionObserver(
        ([e]) => {
            if (e.intersectionRatio >= 1) {
                Gallery.mediaViewed(mediaId, isVideo)
            }
        }, {threshold: [1]}
    );
    observer.observe(mediaEl);
}

export async function observeElement(querySelector, timeout = 200, onClass = 'on', pinClass = 'is-pinned') {
    return new Promise((resolve, reject) => {
     const wrapper = querySelector
    if(!wrapper) reject()
    if (wrapper) {
        setTimeout(() => {
            wrapper.classList.add(onClass)
        }, timeout)
        setTimeout(() => {
            const observer = new IntersectionObserver(
                ([e]) => e.target.classList.toggle(pinClass, e.intersectionRatio < 1),
                {threshold: [1]}
            );
            observer.observe(wrapper);
            resolve(observer)
        }, timeout)
    }
   });
}